import { customAlphabet } from 'nanoid';

const alphabet =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

export const uniqueId = customAlphabet(alphabet, 18);
export const uniqueJId = customAlphabet(alphabet, 4);
